// Helper to handle click selection semantics (single / ctrl-toggle / shift-range)
export function selectWithModifiers({
  itemsMap,
  selected = [],
  clickedUid,
  ctrlDown = false,
  shiftDown = false,
  shiftAnchor = false,
  selectMultiple = true,
}) {
  // Clone selected to avoid mutating caller arrays unexpectedly
  const newSelected = Array.isArray(selected) ? [...selected] : [];
  let newAnchor = shiftAnchor;

  // Safety: ensure clicked exists in map
  if (!clickedUid) {
    return { selected: newSelected, shiftAnchor: newAnchor };
  }

  if (!ctrlDown && !shiftDown) {
    // normal click: select single (replace selection)
    if (selectMultiple) {
      newSelected.length = 0;
      newSelected.push(clickedUid);
    } else {
      newSelected.length = 0;
      newSelected.push(clickedUid);
    }
    newAnchor = clickedUid;
  } else if (ctrlDown) {
    // toggle selection
    const idx = newSelected.indexOf(clickedUid);
    if (idx === -1) {
      newSelected.push(clickedUid);
      newAnchor = clickedUid;
    } else {
      newSelected.splice(idx, 1);
      if (newSelected.length === 0) newAnchor = false;
    }
  } else if (shiftDown) {
    // range selection between anchor and clicked
    if (newAnchor && itemsMap && itemsMap[newAnchor]) {
      const start = itemsMap[newAnchor].index;
      const end = itemsMap[clickedUid].index;
      const list = Object.values(itemsMap);
      for (let i = 0; i < list.length; i++) {
        const idxVal = list[i].index;
        if (
          (idxVal >= start && idxVal <= end) ||
          (idxVal <= start && idxVal >= end)
        ) {
          if (!newSelected.includes(list[i].uid)) {
            newSelected.push(list[i].uid);
          }
        }
      }
    } else {
      if (!newSelected.includes(clickedUid)) newSelected.push(clickedUid);
    }
    newAnchor = clickedUid;
  }

  return { selected: newSelected, shiftAnchor: newAnchor };
}
